import { render, staticRenderFns } from "./CustomerAccountsReceivableStatusTable.vue?vue&type=template&id=6f5d7564&scoped=true&"
import script from "./CustomerAccountsReceivableStatusTable.vue?vue&type=script&lang=js&"
export * from "./CustomerAccountsReceivableStatusTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5d7564",
  null
  
)

export default component.exports